import { useLocation } from "react-router";
import "./Footer.css";
import { useEffect, useState } from "react";

function Footer(props: any) {
  console.log(props.onViewDocPage);
  return (
    <div className={props.onViewDocPage || props.onEditPage ? "footer-section-edit d-flex gap-2 gap-lg-4 flex-lg-row flex-column justify-content-lg-between align-items-center" : "footer-section d-flex gap-2 gap-lg-4 py-lg-3 py-2 flex-lg-row flex-column justify-content-lg-between align-items-center"}>
      <a
        className="d-flex align-items-center"
        href="https://www.williamslea.com"
        target="_blank"
        rel="noreferrer">
        <img
          src={require("../../assets/img/wl_white_logo.png")}
          alt=""
        />
      </a>
      <div className="d-flex gap-4">
        <a
          target="_blank"
          href="https://www.williamslea.com/about"
          className={props.onEditPage || props.onViewDocPage ? "footer-link-edit" : "footer-link"}
          rel="noreferrer">
          About
        </a>
        <a
          target="_blank"
          href="https://www.williamslea.com/privacy-statement"
          className={props.onEditPage || props.onViewDocPage ? "footer-link-edit" : "footer-link"}
          rel="noreferrer">
          Privacy
        </a>
        <a
          target="blank"
          href="https://www.williamslea.com/cookies"
          className={props.onEditPage || props.onViewDocPage ? "footer-link-edit" : "footer-link"}>
          Cookies
        </a>
      </div>
      <p style={{ marginTop: "1px", textAlign: "center" }}>Copyright © 2024 Williams Lea. All Rights Reserved. </p>
    </div>
  );
}

export default Footer;
